/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ControlStatus {
  status?: ControlStatusEnum;
  updated_by?: string;
  last_edit_time?: string;
  history_note?: { [key: string]: string };
  note?: string;
}
export type ControlStatusEnum =
  | 'NOT_STARTED'
  | 'IN_PROGRESS'
  | 'READY_FOR_AUDIT'
  | 'GAP'
  | 'ISSUE'
  | 'APPROVED_BY_AUDITOR'
  | 'COMPLIANT' // TODO: TO BE REMOVED!!!
  | 'MONITORING'
  | 'NOT_APPLICABLE'
  | 'NOT_READY_FOR_AUDIT'; // relevant for auditors users only
export const ControlStatusEnum = {
  NOTSTARTED: 'NOT_STARTED' as ControlStatusEnum,
  INPROGRESS: 'IN_PROGRESS' as ControlStatusEnum,
  READY_FOR_AUDIT: 'READY_FOR_AUDIT' as ControlStatusEnum,
  GAP: 'GAP' as ControlStatusEnum,
  ISSUE: 'ISSUE' as ControlStatusEnum,
  APPROVED_BY_AUDITOR: 'APPROVED_BY_AUDITOR' as ControlStatusEnum,
  COMPLIANT: 'COMPLIANT' as ControlStatusEnum, // TODO: TO BE REMOVED!!!
  MONITORING: 'MONITORING' as ControlStatusEnum,
  NOT_APPLICABLE: 'NOT_APPLICABLE' as ControlStatusEnum,
  NOT_READY_FOR_AUDIT: 'NOT_READY_FOR_AUDIT' as ControlStatusEnum,
};
